import React, { useState, useEffect, createRef } from "react";
import { UnitBox } from "./UnitBox";
import Background_unit from "../../images/unit/Background_unit.png";
import unit_black from "../../images/unit/Render/unit_black.png";
import unit_white from "../../images/unit/Render/unit_white.png";
import unit_white_logo from "../../images/unit/Render/unit_white_logo.png";
import chat from "../../images/unit/chat.svg";
import styled from "styled-components/macro";
import { MonitorBox } from "./MonitorBox";
import { UnitData } from "./UnitData";
import { UnitTool } from "./UnitTools";
import { useScreenshot } from "use-react-screenshot";
import { itemsPopUp } from "./items";
import { useSelector } from "react-redux";

const column1 = [itemsPopUp.monitor, itemsPopUp.shop];
const column2 = [
  itemsPopUp.vr,
  itemsPopUp.homeTheaterProjector,
  itemsPopUp.consolePlay,
  itemsPopUp.airfryer,
  itemsPopUp.mixer,
];
const column3 = [itemsPopUp.robotMop, itemsPopUp.dyson];
const column4 = [
  itemsPopUp.drillDriver,
  itemsPopUp.printer,
  itemsPopUp.foldingChairs,
];

export const unitBoxSizes = {
  small: 75,
  medium: 158,
  large: 324,
  xl: 490,
};

const CreateUnitPageYishai = ({ onQuoteClick }) => {
  useSelector(mapStateToProps);

  const unitColor = "#FFFFFF";

  const [columns] = useState([column1, column2, column3, column4]);
  const [itemsCount, setItemsCount] = useState({});
  const [unitDirection, setUnitDirection] = useState({ x: 0, y: 0 });
  const [unitScale, setUnitScale] = useState(1);
  const [background, setBackground] = useState();
  const [logoImage, setLogoImage] = useState();
  const [showDimensions, setShowDimensions] = useState(false);
  const [colorUnit, setColorUnit] = useState("#efefef");
  const unitWrapperRef = createRef();
  const [, takeScreenshot] = useScreenshot();
  const getImage = () => takeScreenshot(unitWrapperRef.current);

  useEffect(() => {
    const items = {};
    columns.map((e) =>
      e.map(
        (i) =>
          (items[i.id] = {
            count: (items[i.id]?.count || 0) + (i.countInUnit || 1),
            item: i,
          })
      )
    );
    delete items.undefined;

    setItemsCount(items);
  }, [columns]);

  const _renderUnitColors = () => {
    switch (colorUnit) {
      case "#4a4a4a":
        return logoImage ? unit_black : unit_black;
      case "#efefef":
        return logoImage ? unit_white_logo : unit_white;
      case "#b6af9c":
        return logoImage ? unit_black : unit_black;
      default:
        return logoImage ? unit_white_logo : unit_white;
    }
  };

  const _renderColumns = () => {
    console.log({ columns });

    return columns?.map((column, columnIndex) => {
      return (
        <div key={columnIndex}>
          {" "}
          {column?.map((item, index) => {
            if (!item) return null;

            if (item.type === "monitor") {
              return (
                <MonitorBox
                  key={index}
                  colorUnit={colorUnit}
                  logo={logoImage && URL.createObjectURL(logoImage)}
                />
              );
            }
            return (
              <UnitBox
                colorUnit={colorUnit}
                item={item}
                showTopDivider
                quantity={itemsCount[item.id]}
                showBottomDivider={index + 1 === column.length}
                showRightDivider={columnIndex + 1 !== columns.length}
                key={index}
              />
            );
          })}
        </div>
      );
    });
  };

  const cmHorizontal = 48.25 * columns.length + 2 * (columns.length - 1);
  const cmVertical = 210;

  return (
    <Wrapper>
      <div ref={unitWrapperRef} style={{ height: "100%" }}>
        <Img
          unitDirection={unitDirection}
          unitScale={unitScale}
          src={background ? URL.createObjectURL(background) : Background_unit}
          alt={"Background"}
        />
        <UnitFullWrapper className="animate__animated animate__fadeIn animate__delay-1s">
          <WrapperUnit>
            {showDimensions && (
              <DimensionsHorizontalWrapper>
                <div>{`${fromCmToInch(cmHorizontal)}`}</div>
                <DimensionsHorizontal />
              </DimensionsHorizontalWrapper>
            )}
            {showDimensions && (
              <DimensionsVerticalWrapper>
                <div style={{ padding: "0 4px" }}>{`${fromCmToInch(
                  cmVertical
                )}`}</div>
                <DimensionsVertical />
              </DimensionsVerticalWrapper>
            )}
            <Shelf frameColor={colorUnit} color={unitColor} />
            <Unit>{_renderColumns()}</Unit>

            <Shelf frameColor={colorUnit} height={30} />
            <RenderImage src={_renderUnitColors()} alt={"Render01"} />
          </WrapperUnit>
        </UnitFullWrapper>
      </div>
      <div
        style={{
          position: "absolute",
          right: "70px",
          top: "70px",
          bottom: "68px",
        }}
      >
        <UnitData
          onSharePress={async () => {
            const res = await getImage();
            // const data = new Blob([res], {type: 'image/png'});
            // const file = new File([data], "univ.png");

            // const csvURL = window.URL.createObjectURL(data)
            // console.log(file);

            let tempLink = document.createElement("a");
            tempLink.href = res;
            tempLink.setAttribute("download", "univ.png");
            tempLink.click();
          }}
          onQuoteClick={onQuoteClick}
          itemsCount={itemsCount}
        />
      </div>
      <ChatWrapper>
        <div style={{ margin: "0 22px" }}>Need help?</div>
        <img width={32} height={32} src={chat} alt={"chat"} />
      </ChatWrapper>

      <div style={{ position: "absolute", left: "70px", top: "70px" }}>
        <UnitTool
          onDimensionsClick={() => setShowDimensions(!showDimensions)}
          onLogoChange={setLogoImage}
          onColorClick={setColorUnit}
          onBackgroundChange={setBackground}
          onScaleClick={(size) => {
            let scale = unitScale;
            switch (size) {
              case "bigger":
                scale += 0.05;
                break;
              case "smaller":
                scale -= 0.05;
                break;
              default:
                break;
            }
            setUnitScale(scale);
          }}
          onMoveClick={(direction) => {
            let x = unitDirection.x;
            let y = unitDirection.y;

            switch (direction) {
              case "down":
                y += 3;
                break;
              case "up":
                y -= 3;
                break;
              case "right":
                x += 3;
                break;
              case "left":
                x -= 3;
                break;
              default:
                break;
            }

            setUnitDirection({ x, y });
          }}
        />
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  height: calc(100vh - 60px);
`;
const WrapperUnit = styled.div`
  //transform: translate(340px, 45px);
  //transform: translate(420px, 130px);
  margin-top: 20px;
  transform: scale(0.9);
  position: fixed;
`;
const ChatWrapper = styled.div`
  position: absolute;
  right: 70px;
  bottom: 0;
  width: 272px;
  background-color: white;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
  padding: 10px;
  font-size: 18px;
  color: #4b4b4b;
  font-family: Manrope, serif;
  flex-direction: row;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
const UnitFullWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Unit = styled.div`
  opacity: 0;
  z-index: 999;
  display: flex;
  position: relative;
  flex-direction: row;
`;

const Shelf = styled.div`
  display: flex;
  position: relative;
  height: ${({ height = 70 }) => height}px;
  width: 100%;
  opacity: 0;
  border-radius: 2px;
  box-shadow: 1px 1px 3px #4a4a4a;
  background-color: ${({ frameColor }) => frameColor};
`;
const Img = styled.img`
  transform: scale(${({ unitScale }) => unitScale})
    translate(
      ${({ unitDirection }) => unitDirection.x}px,
      ${({ unitDirection }) => unitDirection.y}px
    );
  position: absolute;
  top: 58px;
  bottom: 0;
  height: calc(100vh - 58px);
  left: 0;
  right: 0;
  z-index: 0;
  object-fit: contain;
  margin: auto;
`;

const RenderImage = styled.img`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 0;
  object-fit: contain;
`;

const DimensionsVerticalWrapper = styled.div`
  position: absolute;
  top: 0;
  left: -68px;
  height: 100%;
  z-index: 1;
  color: #ffffff;
  font-size: 20px;
  text-align: center;
  display: flex;
  align-items: center;
`;

const DimensionsVertical = styled.div`
  height: 100%;
  z-index: 1;
  width: 3px;
  background-color: #ffffff;
  border-radius: 8px;
`;

const DimensionsHorizontalWrapper = styled.div`
  position: absolute;
  top: -35px;
  left: 0;
  width: 100%;
  z-index: 1;
  color: #ffffff;
  font-size: 20px;
  text-align: center;
`;

const DimensionsHorizontal = styled.div`
  width: 100%;
  z-index: 1;
  height: 3px;
  background-color: #ffffff;
  border-radius: 8px;
`;
export { CreateUnitPageYishai };

const fromCmToInch = (cm) => {
  let inches = (cm * 0.393700787).toFixed(0);
  const feet = Math.floor(inches / 12);
  inches %= 12;

  return `${feet}" ${inches}'`;
};

const mapStateToProps = ({ ItemsReducer }) => {
  return { items: ItemsReducer.items };
};
